export default __webpack_public_path__ + "static/media/Rectangle23.6e092764.jpg";